var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.855957,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FF933B",
    fillOpacity: 0.06
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.35596,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "url(#paint0_linear_1181_57646)",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 15.856L15 33.856L33 15.856Z",
    fill: "#FF9407"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 15.856L15 33.856L33 15.856Z",
    fill: "#FF933B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 15.856L15 33.856",
    stroke: "#FF9407",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 15.856L15 33.856",
    stroke: "#FF933B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33.856L15 15.856L33 33.856Z",
    fill: "#FF9407"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33.856L15 15.856L33 33.856Z",
    fill: "#FF933B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33.856L15 15.856",
    stroke: "#FF9407",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33.856L15 15.856",
    stroke: "#FF933B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1181_57646",
    x1: 1.54839,
    y1: 0.855957,
    x2: 55.4357,
    y2: 12.4842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.52
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.df1cb11e2d79ef60fcbda444f59bf634.svg";
export { ForwardRef as ReactComponent };